import { render } from "./EditUserModal.vue?vue&type=template&id=608670b4&scoped=true"
import script from "./EditUserModal.vue?vue&type=script&lang=js"
export * from "./EditUserModal.vue?vue&type=script&lang=js"

import "./EditUserModal.vue?vue&type=style&index=0&id=608670b4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608670b4"]])

export default __exports__